import { IBrandRoutes } from 'components/layout/types';
import { LazyRoute, lazyWithFallback } from 'components/layout/util';
import { StoreStatus } from 'remote/api/restaurants';
import { relativeRoutes } from 'utils/routing';

const NoStoresOpenDeliveryModal: LazyRoute = lazyWithFallback(() =>
  import('components/modal-no-delivery-stores-open/no-stores-open-delivery-modal')
);

const brandRoutes: IBrandRoutes = {
  [relativeRoutes[StoreStatus.CLOSED]]: NoStoresOpenDeliveryModal,
};

export default brandRoutes;
